import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { useBulkChange } from "./use-bulk-change.hook";
import { useTableCellNavigation } from "./use-table-cell-navigation.hook";
import "./custom-cells.css";

export const CheckboxCustomCell = (props: GridCustomCellProps) => {
	const booleanValue = props.field ? props.dataItem[props.field] : null;

	const { handleChange } = useBulkChange({
		dataItem: props.dataItem,
		dataIndex: props.dataIndex,
		field: props.field,
		onChange: props.onChange,
	});

	const { handleKeyDown: handleNavigationKeyDown } = useTableCellNavigation({
		field: props.field,
		dataIndex: props.dataIndex,
		focusSelector: (targetField: string, targetRowIndex: number) =>
			`input[type="checkbox"][data-field="${targetField}"][data-row-index="${targetRowIndex}"]`,
	});

	const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
		const metaKeyPressed = event.metaKey || event.ctrlKey;
		const shiftKeyPressed = event.shiftKey;
		const altKeyPressed = event.altKey;
		const newValue = !booleanValue;

		handleChange(newValue, metaKeyPressed, shiftKeyPressed, altKeyPressed);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === " " || event.key === "Enter") {
			event.preventDefault();
			const metaKeyPressed = event.metaKey || event.ctrlKey;
			const shiftKeyPressed = event.shiftKey;
			const altKeyPressed = event.altKey;
			const newValue = !booleanValue;
			handleChange(newValue, metaKeyPressed, shiftKeyPressed, altKeyPressed);
			return;
		}

		if (event.key === "Backspace") {
			event.preventDefault();
			handleChange(false, event.metaKey || event.ctrlKey, event.shiftKey, event.altKey);
			return;
		}

		handleNavigationKeyDown(event);
	};

	return (
		<td className="custom-td">
			<input
				type="checkbox"
				id="scales"
				name="scales"
				checked={booleanValue}
				onClick={handleClick}
				onKeyDown={handleKeyDown}
				data-field={props.field}
				data-row-index={props.dataIndex}
				tabIndex={0}
				readOnly
			/>
		</td>
	);
};
